/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Media_TitleInputs */



/**
* | output |
* | --- |
* | "OCR Media - Extract Burnt-In Text" |
*
* @param {Ocr_Media_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_media_title = /** @type {((inputs?: Ocr_Media_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Media_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supports OCR - Extraction de texte incrusté")
	if (locale === "de") return /** @type {LocalizedString} */ ("OCR Media – Eingebrannten Text extrahieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("OCR Media - Estrazione del testo incorporato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("OCR Media - Извлечение встроенного текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Medios OCR - Extraer texto incrustado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("OCR 介质 - 提取嵌入式文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCRメディア - 焼き付いたテキストの抽出")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओसीआर मीडिया - जले हुए पाठ को निकालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mídia OCR - Extrair texto gravado")
	return /** @type {LocalizedString} */ ("OCR Media - Extract Burnt-In Text")
});